import { render, staticRenderFns } from "./crmContacts.vue?vue&type=template&id=2560aca5"
import script from "./crmContacts.vue?vue&type=script&lang=js"
export * from "./crmContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports